<script>
export default {
  name: "gotQuestions",
  methods: {
    redirectToHelpCenter() {
      console.log("Redirect to FAQ");
    }
  }
};
</script>

<template>
  <el-row style="padding: 40px 16px; background-color:#101010">
    <el-col :span="24">
      <span class="title-text text400">Still have</span>
    </el-col>
    <el-col :span="24">
      <span class="title-text text600">questions?</span>
    </el-col>
    <el-col
      :span="24"
      style="margin-top: 40px; display: flex; flex-direction: column"
    >
      <el-button class="ua-primary-btn" @click="redirectToHelpCenter">
        Help Center
      </el-button>
    </el-col>
  </el-row>
</template>

<style scoped>
.ua-primary-btn {
  color: #ffbe00;
  text-align: center;
  border: 3px solid #ffbe00;
  background-color: #2d2d2d;
  padding: 14px 60px;
  font: 600 20px Metropolis, sans-serif;
}

.title-text {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 40px;
  font-style: normal;
  line-height: normal;
}

.text400 {
  font-weight: 400;
}

.text600 {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/package/gotQuestions.vue